var render = function render(_c,_vm){return _c('PRentalStatus',{attrs:{"status":_vm.props.item[_vm.props.value]}})
}
var staticRenderFns = []

export { render, staticRenderFns }